import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NosServices.css';
import { 
  FaFileAlt, 
  FaPlane, 
  FaClipboardList, 
  FaBriefcase, 
  FaLightbulb, 
  FaMoneyBillWave, 
  FaUserGraduate, 
  FaBrain,
  FaBook,
  FaBalanceScale,
  FaCalendarAlt,
  FaUsers,
  FaHome,
  FaGraduationCap,
  FaHandshake,
  FaGlobeEurope
} from 'react-icons/fa';

const NosServices = () => {
  const services = [
    {
      id: 1,
      icon: <FaFileAlt />,
      title: "Renouvellement de titre de séjour",
      description: "Accompagnement complet pour le renouvellement de votre titre de séjour étudiant.",
      category: "Administratif",
      color: "#1e3c72",
      slug: "renouvellement-titre-sejour"
    },
    {
      id: 2,
      icon: <FaPlane />,
      title: "Voyage & Tourisme : Explorer la France et au-delà",
      description: "Organisation de voyages et découvertes culturelles en France et en Europe.",
      category: "Loisirs",
      color: "#dc143c",
      slug: "voyage-tourisme"
    },
    {
      id: 3,
      icon: <FaClipboardList />,
      title: "Les démarches administratives pour les étudiants étrangers",
      description: "Guidance pour toutes les formalités administratives nécessaires.",
      category: "Administratif",
      color: "#2a5298",
      slug: "demarches-administratives"
    },
    {
      id: 4,
      icon: <FaBriefcase />,
      title: "Le marché du travail en France et la recherche de job étudiant",
      description: "Conseils et accompagnement pour trouver un emploi étudiant en France.",
      category: "Emploi",
      color: "#ff3855",
      slug: "marche-travail"
    },
    {
      id: 5,
      icon: <FaLightbulb />,
      title: "L'entrepreneuriat pour les étudiants étrangers",
      description: "Soutien pour les projets entrepreneuriaux des étudiants internationaux.",
      category: "Professionnel",
      color: "#ff8c00",
      slug: "entrepreneuriat"
    },
    {
      id: 6,
      icon: <FaMoneyBillWave />,
      title: "Aide financière pour les étudiants étrangers",
      description: "Information et assistance pour les aides financières et bourses.",
      category: "Financier",
      color: "#2e8b57",
      slug: "aide-financiere"
    },
    {
      id: 7,
      icon: <FaUserGraduate />,
      title: "Conseil et orientation projet d'études et professionnel",
      description: "Accompagnement personnalisé pour votre orientation académique et professionnelle.",
      category: "Orientation",
      color: "#8a2be2",
      slug: "conseil-orientation"
    },
    {
      id: 8,
      icon: <FaBrain />,
      title: "La gestion de la santé mentale",
      description: "Soutien psychologique et ressources pour le bien-être mental.",
      category: "Santé",
      color: "#ff6b6b",
      slug: "sante-mentale"
    },
    {
      id: 9,
      icon: <FaBook />,
      title: "Le système éducatif français et les méthodes pédagogiques",
      description: "Compréhension du système universitaire français et adaptation aux méthodes locales.",
      category: "Académique",
      color: "#1e90ff",
      slug: "systeme-educatif"
    },
    {
      id: 10,
      icon: <FaBalanceScale />,
      title: "Les droits juridiques des étudiants étrangers",
      description: "Information sur vos droits et devoirs en tant qu'étudiant étranger en France.",
      category: "Juridique",
      color: "#ffd700",
      slug: "droits-juridiques"
    },
    {
      id: 11,
      icon: <FaCalendarAlt />,
      title: "Événements culturels : Découverte de la France",
      description: "Participation à des événements culturels pour découvrir la France.",
      category: "Culture",
      color: "#ff69b4",
      slug: "evenements-culturels"
    },
    {
      id: 12,
      icon: <FaUsers />,
      title: "L'intégration culturelle et sociale en France",
      description: "Activités et conseils pour une intégration réussie dans la société française.",
      category: "Social",
      color: "#00ced1",
      slug: "integration-culturelle"
    },
    {
      id: 13,
      icon: <FaHome />,
      title: "La recherche de logement en France",
      description: "Assistance complète pour trouver et sécuriser un logement étudiant.",
      category: "Logement",
      color: "#32cd32",
      slug: "recherche-logement"
    },
    {
      id: 14,
      icon: <FaGraduationCap />,
      title: "Les opportunités de financement et de bourses",
      description: "Accès aux informations sur les bourses et financements disponibles.",
      category: "Financier",
      color: "#ff4500",
      slug: "opportunites-financement"
    },
    {
      id: 15,
      icon: <FaHandshake />,
      title: "La vie après les études en France",
      description: "Préparation à la vie professionnelle et au séjour post-diplôme en France.",
      category: "Professionnel",
      color: "#6a5acd",
      slug: "vie-apres-etudes"
    },
    {
      id: 16,
      icon: <FaGlobeEurope />,
      title: "Immigration & Procédures consulaires",
      description: "Assistance pour les procédures d'immigration et démarches consulaires.",
      category: "Administratif",
      color: "#20b2aa",
      slug: "immigration-consulaire"
    }
  ];

  const [activeFilter, setActiveFilter] = useState('all');
  const categories = [...new Set(services.map(service => service.category))];

  const filteredServices = activeFilter === 'all' 
    ? services 
    : services.filter(service => service.category === activeFilter);

  return (
    <section className="ns-services-section" id="ns-nos-services">
      <div className="ns-services-background">
        <div className="ns-services-glow ns-services-glow-1"></div>
        <div className="ns-services-glow ns-services-glow-2"></div>
        <div className="ns-services-pattern"></div>
      </div>

      <div className="ns-services-container">
        <div className="ns-services-header">
          <h2 className="ns-services-title">
            Nos services
            <span className="ns-services-title-underline"></span>
          </h2>
          <p className="ns-services-subtitle">
            Un accompagnement complet pour chaque étape de votre parcours d'étudiant étranger en France
          </p>
        </div>

        <div className="ns-services-filters">
          <button 
            className={`ns-filter-btn ${activeFilter === 'all' ? 'ns-active' : ''}`} 
            onClick={() => setActiveFilter('all')}
          >
            Tous les services
          </button>
          {categories.map((category, index) => (
            <button 
              key={index} 
              className={`ns-filter-btn ${activeFilter === category ? 'ns-active' : ''}`}
              onClick={() => setActiveFilter(category)}
              style={{ 
                borderColor: getCategoryColor(category),
                color: activeFilter === category ? getCategoryColor(category) : '#666'
              }}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="ns-services-grid">
          {filteredServices.map((service) => (
            <div 
              className="ns-service-card" 
              key={service.id}
            >
              <div className="ns-service-card-inner">
                <div 
                  className="ns-service-category-badge"
                  style={{ 
                    backgroundColor: `${service.color}15`,
                    color: service.color,
                    borderColor: service.color
                  }}
                >
                  {service.category}
                </div>

                <div 
                  className="ns-service-icon-wrapper"
                  style={{ 
                    background: `linear-gradient(135deg, ${service.color}, ${service.color}dd)`,
                    boxShadow: `0 10px 30px ${service.color}40`
                  }}
                >
                  <div className="ns-service-icon">
                    {service.icon}
                  </div>
                </div>

                <h3 className="ns-service-title">
                  {service.title}
                </h3>
                
                <p className="ns-service-description">
                  {service.description}
                </p>

                <Link to={`/services/${service.slug}`} className="ns-service-action-btn">
                  <span>En savoir plus</span>
                  <svg className="ns-action-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="currentColor"/>
                  </svg>
                </Link>

                <div 
                  className="ns-service-decoration"
                  style={{ 
                    background: `linear-gradient(135deg, ${service.color}10, transparent)`
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const getCategoryColor = (category) => {
  const colors = {
    'Administratif': '#1e3c72',
    'Loisirs': '#dc143c',
    'Emploi': '#ff3855',
    'Professionnel': '#ff8c00',
    'Financier': '#2e8b57',
    'Orientation': '#8a2be2',
    'Santé': '#ff6b6b',
    'Académique': '#1e90ff',
    'Juridique': '#ffd700',
    'Culture': '#ff69b4',
    'Social': '#00ced1',
    'Logement': '#32cd32'
  };
  return colors[category] || '#666';
};

export default NosServices;